/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {NOT_AVAILABLE} from '@/utils/constants'
import * as base64 from 'base64-js'

const DEFAULT_TAG = 'suspicious'

export class YaraSignatureVO {

    // required to access a YaraSignature attribute from the attribute name as string e.g yaraSignature['priority']
    [key: string]: any

    public static fromServiceFormat(snakeCasedYaraSignature: any): YaraSignatureVO {

        let tags = [DEFAULT_TAG]
        if (snakeCasedYaraSignature.tags && snakeCasedYaraSignature.tags.length !== 0) {
            tags = snakeCasedYaraSignature.tags
        }

        return new YaraSignatureVO(
            snakeCasedYaraSignature.category,
            snakeCasedYaraSignature.name,
            snakeCasedYaraSignature.rule_set_name,
            tags,
            snakeCasedYaraSignature.description,
            snakeCasedYaraSignature.confidence,
            snakeCasedYaraSignature.priority,
            snakeCasedYaraSignature.family,
            snakeCasedYaraSignature.file,
            snakeCasedYaraSignature.strings,
            )
    }
    private static hexChar = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']

    // Convert all yara matches to either printable string (eg: "example") or hexa codes (eg: "{ BF 0A 65 2E }")
    private static convertStringsToReadableFormat(yaraStrings: any[]): any[] {
        const readableStrings: any[] = []
        for (const yaraString of yaraStrings) {
            const readableString = yaraString
            readableString[2] = YaraSignatureVO.convertBase64StringToReadableFormat(yaraString[2])
            readableStrings.push(readableString)
        }
        return readableStrings
    }

    private static convertBase64StringToReadableFormat(base64String: string): string {
        let readableString = ''
        try {
            const byteArray = base64.toByteArray(base64String)
            // Check if all bytes are printable
            if (byteArray.every((b: number) => b >= 0x20 && b <= 0x7E)) {
                readableString = String.fromCharCode.apply(null, byteArray)
            } else {
                readableString = '{ '
                for (const b of byteArray) {
                    readableString += YaraSignatureVO.byteToHex(b) + ' '
                }
                readableString += '}'
            }
        } catch (e) {
            readableString = base64String
        }

        return readableString
    }

    /* tslint:disable:no-bitwise */
    private static byteToHex(b: number): string {
        return this.hexChar[(b >> 4) & 0x0f] + this.hexChar[b & 0x0f]
    }
    /* tslint:enable:no-bitwise */

    public readonly strings: any[]

    constructor(public category: string = NOT_AVAILABLE,
                public ruleName: string = NOT_AVAILABLE,
                public rulesetName: string = NOT_AVAILABLE,
                public tags: string[] = [],
                public description: string = NOT_AVAILABLE,
                public confidence: number = 0,
                public priority: number = 0,
                public family: string = NOT_AVAILABLE,
                public file: string = NOT_AVAILABLE,
                yaraStrings: any[] = [],

    ) {
        this.strings = YaraSignatureVO.convertStringsToReadableFormat(yaraStrings)
    }
}
